export default "__VITE_ASSET__EexyEme1__"